import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Checkbox,
  Button,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { NavLink as RouterLink } from "react-router-dom";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import {
  apiEndpoints,
  apiPostRequest,
  apiGetByIdRequest,
  apiPutRequest,
  apiGetRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { kmMessages } from "src/constant/Messages";
import { decode } from "js-base64";
import { fillMissingTags } from "src/utils/utils";
import Skeleton from "@material-ui/lab/Skeleton";
import Autocomplete from "@material-ui/lab/Autocomplete";

const nameMaxLength = 150;
const descriptionMaxLength = 500;

const formValidation = {
  required: kmMessages.error.form_validation.field_required,
  maxLength: `${kmMessages.error.form_validation.field_maxlengthnum}`,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const FolderForm = ({
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  editMode,
  ...rest
}) => {
  const classes = useStyles();
  const { parentFolderId } = useParams();
  const { folderId } = useParams();
  const { siblingDocumentId } = useParams();
  const { siblingDocumentName } = useParams();
  const navigate = useNavigate();
  const [folderData, setFolderData] = useState();
  const [selectedAccess, setSelectedAccess] = useState("afterlogin");
  const [limitedAccessWorkGroupVisible, setLimitedAccessWorkGroupVisible] = useState(false);
  const [limitedAccessWorkGroup, setLimitedAccessWorkGroup] = useState(false);
  const [workingGroups, setWorkingGroups] = useState(null);
  const [selectedWorkingGroups, setSelectedWorkingGroups] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const { handleSubmit, setValue, control, errors } = useForm();

  useEffect(() => {
    if (searchParams.get('workGroupsIds') || searchParams.get('rootLevel')){
      setLimitedAccessWorkGroupVisible(true)
    }
    if (searchParams.get('workGroupsIds')){
      setLimitedAccessWorkGroup(true); //parent is limited so child also should be
    }
    if (editMode) {
      enableGlobalLoader();
      apiGetByIdRequest(apiEndpoints.getFolderDetails.path, folderId, true)
        .then((data) => {
          disableGlobalLoader();
          setValue("name", data.name);
          setValue("description", data.description);
          setValue("access", data.publicAccess ? "public" : "afterlogin");
          setSelectedAccess(data.publicAccess ? "public" : "afterlogin");
          setFolderData(data);
          setSelectedWorkingGroups(data.workingGroups);
          if (data.workingGroups && data.workingGroups.length > 0) {
            setLimitedAccessWorkGroup(true);
          }
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response) {
            if (error.response.status === 403) {
              navigate("/nieuprawnionydostep");
            } else if (error.response.status === 401) {
              navigate("/logowanie");
            }
          }
        });
    }
    return () => {};
  }, []);

  useEffect(() => {
    setTimeout(fillMissingTags(), 1000);
    return () => {};
  }, []);

  useEffect(() => {
    reloadWorkingGroups();
    return () => {};
  }, [limitedAccessWorkGroup]);

  const reloadWorkingGroups = () => {
    console.log(limitedAccessWorkGroup);
    if (limitedAccessWorkGroup) {
      const workGroupsIdsString = searchParams.get('workGroupsIds');
      const workGroupsIds = workGroupsIdsString ? workGroupsIdsString.split(',').map(Number) : [];

      console.log(workGroupsIds);

      apiGetRequest(apiEndpoints.getWorkingGroups.path, true)
        .then((data) => {
          disableGlobalLoader();
          const filteredGroups = workGroupsIds?.length > 0 ? data.filter(group => workGroupsIds.includes(group.id)) : data;
          setWorkingGroups(filteredGroups);
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          } else {
            navigate("/dokumenty");
          }
        });
    }
  };

  const onSubmit = (values) => {
    if (editMode) {
      enableGlobalLoader();
      apiPutRequest(
        apiEndpoints.updateFolder.path,
        {
          id: folderData.id,
          name: values.name,
          description: values.description,
          position: values.position,
          publicAccess: values.access === "public" ? true : false,
          siblingId: siblingDocumentId,
          workGroupsIds:  values.workinggroups ? values.workinggroups.map(
            (workinggroup) => workinggroup.id
          ) : null
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          if (folderData.parentFolderId) {
            navigate("/dokumenty/" + folderData.parentFolderId);
          } else {
            navigate("/dokumenty");
          }
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          } else {
            handleDocumentError(error);
          }
        });
    } else {
      enableGlobalLoader();

      apiPostRequest(
        apiEndpoints.addFolder.path,
        {
          parentId: parentFolderId,
          name: values.name,
          description: values.description,
          position: values.position,
          publicAccess: values.access === "public" ? true : false,
          siblingId: siblingDocumentId,
          workGroupsIds: values.workinggroups ? values.workinggroups.map(
            (workinggroup) => workinggroup.id
          ) : null
        },
        true
      )
        .then((data) => {
          if (parentFolderId) {
            navigate("/dokumenty/" + parentFolderId);
          } else {
            navigate("/dokumenty");
          }

          disableGlobalLoader();
        })
        .catch((error) => {
          disableGlobalLoader();

          if (error.response && error.response.status === 401) {
            setLogoutUser();
          } else {
            handleDocumentError(error);
          }
        });
    }
  };

  const handleDocumentError = (error) => {
    if (
      error.response.status === 403 &&
      error.response.data &&
      error.response.data.code === "ERROR_NOT_PUBLIC_ACCESS_PARENT"
    ) {
      displaySnackbar({
        isOpen: true,
        severity: "error",
        autoHideDuration: 8000,
        message:
          "Katalog nadrzędny nie jest dostępny publicznie. Dodawany/edytowany katalog nie może mieć dostępu publicznego.",
      });
    } else if (error.response.status === 400 &&
      error.response.data) {
        switch (error.response.data.code) {
          case "ERROR_MISSING_WG_PARENT":
            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 8000,
              message:
                "Należy wybrać grupę. Katalog podrzędny do katalogu ograniczonego do wybranych grup, nie może być dostępny bez ograniczenia do co najmniej jednej grupy katalogu nadrzędnego.",
            });
            break;
          case "ERROR_WG_USED_FOR_DESCENDANTS":
            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 8000,
              message:
                "Usuwana grupa/grupy są przypisane do katalogów podrzędnych dlatego nie mogą być usunięte. Aby usunąć grupę należy w pierszej kolejności usunąć ją z katalogów podrzędnych.",
            });
            break;
          default:
            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 8000,
              message: kmMessages.error.global.genericerror,
            });
        }
    } else {
      displaySnackbar({
        isOpen: true,
        severity: "error",
        autoHideDuration: 8000,
        message: kmMessages.error.global.genericerror,
      });
    }
  };

  const handleLimitedAccessWorkGroupChange = (event, parentProps) => {
    setLimitedAccessWorkGroup(event.target.checked);
    parentProps.onChange(event.target.checked);
  };

  return (
    <Card className={clsx(classes.root)}>
      <Box component="main">
        <Grid container className={classes.root}>
          <Grid item xs={12} elevation={2}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl fullWidth className={classes.formcontrol}>
                <Controller
                  as={
                    <TextField
                      error={errors.name ? true : false}
                      id="name"
                      name="name"
                      label="Nazwa"
                      type="text"
                      helperText={
                        errors.name &&
                        (formValidation[errors.name.type] || "").replaceAll(
                          "{maxlen}",
                          nameMaxLength
                        )
                      }
                    />
                  }
                  name="name"
                  defaultValue=""
                  control={control}
                  rules={{ required: true, maxLength: nameMaxLength }}
                />
              </FormControl>
              <FormControl fullWidth className={classes.formcontrol}>
                <Controller
                  as={
                    <TextField
                      error={errors.description ? true : false}
                      id="description"
                      name="description"
                      label="Opis"
                      placeholder="Opis"
                      multiline
                      helperText={
                        errors.description &&
                        (
                          formValidation[errors.description.type] || ""
                        ).replaceAll("{maxlen}", descriptionMaxLength)
                      }
                    />
                  }
                  name="description"
                  defaultValue=""
                  control={control}
                  rules={{ maxLength: descriptionMaxLength }}
                />
              </FormControl>
              {limitedAccessWorkGroupVisible ? (<><FormControlLabel
                control={
                  <Controller
                    name="limitedaccessworkgroup"
                    control={control}
                    defaultValue={limitedAccessWorkGroup}
                    render={(props) => (
                      <Checkbox
                        {...props}
                        id="limitedaccessworkgroup"
                        checked={limitedAccessWorkGroup}
                        onChange={(e) =>
                          handleLimitedAccessWorkGroupChange(e, props)
                        }
                        name="limitedaccessworkgroup"
                        color="primary"
                      />
                    )}
                  />
                }
                label="Ograniczony dostęp/Grupa robocza"
              />
              {limitedAccessWorkGroup ? (
                <FormControl fullWidth className={classes.formcontrol}>
                  {workingGroups ? (
                    <Controller
                      render={({ onChange, ...props }) => (
                        <Autocomplete
                          multiple
                          id="workinggroups-id"
                          options={workingGroups}
                          getOptionLabel={(option) => option.name}
                          getOptionSelected={(option, value) =>
                            value && option.id === value.id
                          }
                          value={props.value}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={errors.workinggroups ? true : false}
                              label="Grupy robocze"
                              placeholder="Grupy robocze"
                              helperText={
                                errors.workinggroups &&
                                (formValidation[errors.workinggroups.type] ||
                                  "")
                              }
                            />
                          )}
                          onChange={(e, data) => onChange(data)}
                        />
                      )}
                      onChange={([, data]) => data}
                      name="workinggroups"
                      control={control}
                      rules={{ required: true }}
                      defaultValue={selectedWorkingGroups}
                    />
                  ) : (
                    <Skeleton />
                  )}
                </FormControl>
              ) : (
                <></>
              )}</>) : <></>}
              {/* <FormControl
                  component="fieldset"
                  className={classes.formcontrol}
                  fullWidth
                >
                  <FormLabel component="legend">Dostęp:</FormLabel>
                  <Controller
                    as={
                      <RadioGroup
                        row
                        aria-label="Dostęp do katalogu"
                        name="access"
                      >
                        <FormControlLabel
                          value="afterlogin"
                          control={<Radio color="primary" />}
                          label="po zalogowaniu"
                        />
                        <FormControlLabel
                          value="public"
                          control={<Radio color="primary" />}
                          label="publiczny"
                        />
                      </RadioGroup>
                    }
                    name="access"
                    defaultValue={selectedAccess}
                    control={control}
                    rules={{ required: true }}
                  />
                </FormControl> */}
              {editMode ? (
                <FormControl
                  component="fieldset"
                  className={classes.formcontrol}
                  fullWidth
                >
                  <FormLabel component="legend">Pozycja w katalogu:</FormLabel>
                  <Controller
                    as={
                      <RadioGroup row aria-label="position" name="position">
                        <FormControlLabel
                          value="nochange"
                          control={<Radio color="primary" />}
                          label="bez zmian"
                        />
                        <FormControlLabel
                          value="start"
                          control={<Radio color="primary" />}
                          label="na początku"
                        />
                        <FormControlLabel
                          value="end"
                          control={<Radio color="primary" />}
                          label="na końcu"
                        />
                        {siblingDocumentId && siblingDocumentId != folderId ? (
                          <FormControlLabel
                            value="afterdoc"
                            control={<Radio color="primary" />}
                            label={
                              siblingDocumentName
                                ? `za '${decode(siblingDocumentName)}'`
                                : "za wskazanym"
                            }
                          />
                        ) : (
                          <></>
                        )}
                      </RadioGroup>
                    }
                    name="position"
                    defaultValue="nochange"
                    control={control}
                    rules={{ required: true }}
                  />
                </FormControl>
              ) : (
                <FormControl
                  component="fieldset"
                  className={classes.formcontrol}
                  fullWidth
                >
                  <FormLabel component="legend">Pozycja w katalogu:</FormLabel>
                  <Controller
                    as={
                      <RadioGroup row aria-label="position" name="position">
                        <FormControlLabel
                          value="start"
                          control={<Radio color="primary" />}
                          label="na początku"
                        />
                        <FormControlLabel
                          value="end"
                          control={<Radio color="primary" />}
                          label="na końcu"
                        />
                        {siblingDocumentId ? (
                          <FormControlLabel
                            value="afterdoc"
                            control={<Radio color="primary" />}
                            label={
                              siblingDocumentName
                                ? `za '${decode(siblingDocumentName)}'`
                                : "za wskazanym"
                            }
                          />
                        ) : (
                          <></>
                        )}
                      </RadioGroup>
                    }
                    name="position"
                    defaultValue="end"
                    control={control}
                    rules={{ required: true }}
                  />
                </FormControl>
              )}

              <Box className={classes.paddingtop}>
                <Button
                  color="primary"
                  className={classes.button}
                  component={RouterLink}
                  to={
                    parentFolderId
                      ? `/dokumenty/${parentFolderId}/`
                      : folderData?.parentFolderId
                      ? `/dokumenty/${folderData.parentFolderId}/`
                      : `/dokumenty`
                  }
                >
                  Anuluj
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.button}
                  endIcon={<SaveIcon />}
                  type="submit"
                >
                  Zapisz
                </Button>
              </Box>
            </form>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(null, mapDispatchToProps)(FolderForm);
